import axios from "axios";
import React, { useState } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./css/main.login.css";
import "./LoginLayout.css";
import Register from "../register/Register";

const Login: React.FC = () => {
  const Cookies = require("js-cookie");
  const navagate = useNavigate();

  const [isShowLoginForm, setIsShowLoginForm] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [isRegister, setIsRegister] = useState(false);

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");


  const handleLogin = async () => {
    const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

    if (userName.trim() === "" || password.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Lỗi đăng nhập",
        text: "Vui lòng điền đầy đủ thông tin",
        customClass: {
          popup: "custom-swal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
      });
      return;
    } else if (userName.trim() != "" || password.trim() != "") {
      try {
        Swal.fire({
          title: "Đang xử lý...",
          text: "Vui lòng đợi giây lát",
          customClass: {
            popup: "custom-swal-processing",
            title: "custom-title",
            htmlContainer: "custom-text",
          },
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });

        // Chờ 3 giây
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await axios
          .post(`${process.env.REACT_APP_URL_API}/auth/login`, {
            username: userName,
            password,
          })
          .then(async (data) => {
            localStorage.setItem(
              "user_info",
              JSON.stringify({
                userName: data.data.user.username,
                coins: data.data.user.coins,
                role: data.data.user.role,
                id: data.data.user._id,
              })
            );

            Cookies.set("access_token", data.data.access_token, {
              expires: 1 / 24,
              secure: false, // Thử false cho iOS
              sameSite: "Lax", // Thử Lax thay vì Strict
            });

            await new Promise((resolve) => setTimeout(resolve, 100));

            if (data.status === 201 && (data.data.user.role === "SUPERADMIN" || data.data.user.role === "ADMIN")) {
              Swal.fire({
                icon: "success",
                title: "Đăng nhập thành công",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
              setTimeout(() => {
                window.location.href = "/admin";
              }, 500);
            } else {
              Swal.fire({
                icon: "success",
                title: "Đăng nhập thành công",
                text: "Vui lòng đợi ít phút. ",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
              setTimeout(() => {
                window.location.href = "/";
              }, 500);
            }
          })
          .catch((err) => {
            if (err.status === 401) {
              Swal.fire({
                icon: "error",
                title: "Lỗi đăng nhập",
                text: "Tài khoản/mật khẩu không chính xác!",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
            }
          });
      } catch (error) {
        return error;
      }
    }
  };

  return (
    <div className="login-page ">
      {/* Desktop: bg-pc.mp4 */}
      <video
        className="fixed top-0 left-0 w-full h-full object-cover -z-10 hidden sm:block"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src={`${process.env.PUBLIC_URL || ""}/assets/bg-pc.mp4`} type="video/mp4" />
      </video>
      {/* Mobile: bg-mb.mp4 */}
      <video
        className="fixed top-0 left-0 w-full h-full object-cover -z-10 block sm:hidden"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src={`${process.env.PUBLIC_URL || ""}/assets/bg-mb.mp4`} type="video/mp4" />
      </video>
      <div
        className={`model-group ${
          isShowLoginForm || isRegister || isLogin ? "active" : ""
        }`}
      >
        <div className="overlay"></div>

        {/* Login Modal */}
        <div
          className={`model-item model-login ${
            isShowLoginForm || isLogin ? "model-login_active" : ""
          }  `}
        >
          <div
            className="btn-closeModel"
            onClick={() => {
              setIsShowLoginForm(false);
              setIsLogin(false);
            }}
          ></div>
          <img
            src="/assets/text-login.png"
            alt="Đăng nhập"
            className="modal-title-image"
          />

          <div className="wrapper">
            <div className="title mb-3">
            </div>
            <form id="loginform" onSubmit={handleLogin}>
              <input
                className="bg-input mb-3"
                type="text"
                id="txtUsername"
                placeholder="Nhập tên tài khoản"
                onChange={(e) => setUserName(e.target.value)}
                maxLength={16}
                minLength={4}
                autoComplete="off"
                required
              />
              <input
                className="bg-input mb-3"
                type="password"
                id="txtPassword"
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Nhập mật khẩu"
                maxLength={16}
                minLength={4}
                autoComplete="off"
                required
              />
              <div className="group-btn mt-4">
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={() => {
                    setIsShowLoginForm(false);
                    setIsLogin(false);
                  }}
                >
                  Hủy
                </button>
                <button
                  type="button"
                  className="btn-confirm"
                  onClick={handleLogin}
                >
                  Đồng ý
                </button>
              </div>
            </form>
            <p className="txt-swith">
              Chưa có tài khoản?{" "}
              <span
                className="link-register"
                onClick={() => {
                  setIsShowLoginForm(false);
                  setIsRegister(true);
                }}
              >
                Đăng ký ngay
              </span>
            </p>
          </div>
        </div>

        {/* Register Modal */}
        <Register
          isRegister={isRegister}
          setIsShowLogin={() => setIsLogin(true)}
          setIsRegister={() => setIsRegister(false)}
        />
      </div>

      <div className="index-page_wrapper">
        <div className="logo login-layout-vertical">
          <img
            src="/assets/logo-login.png"
            alt="Logo"
            className="logo_main"
          />
          <div className="wrapper-content flex flex-col items-center gap-4">
            <button
              type="button"
              className="login-btn-img border-0 bg-transparent p-0 cursor-pointer"
              onClick={() => setIsShowLoginForm(true)}
              aria-label="Đăng nhập"
            >
              <img src="/assets/btn-login.png" alt="Đăng nhập" className="login-btn-img" />
            </button>
            <button
              type="button"
              className="login-btn-img border-0 bg-transparent p-0 cursor-pointer"
              onClick={() => setIsRegister(true)}
              aria-label="Đăng ký"
            >
              <img src="/assets/btn-logout.png" alt="Đăng ký" className="login-btn-img" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
